import { Button } from "@babackapp/ui/components/button";
import { Textarea } from "@babackapp/ui/components/textarea";
import { useState } from "react";
import { selectKnownShops } from "./parse-shop-ids";

/** The API bounds one start request: each shop counts its documents first. */
export const MAX_SHOPS_PER_START = 100;

/**
 * Selects shops from a pasted list of ids, as an alternative to ticking rows.
 * Ids that match no shop of the list are reported and left out.
 */
export function ShopIdsInput({
  knownIds,
  onSelect,
}: {
  knownIds: ReadonlySet<string>;
  onSelect: (shopIds: string[]) => void;
}) {
  const [text, setText] = useState("");
  const [unknown, setUnknown] = useState<string[]>([]);

  const apply = () => {
    const { known, unknown: missing } = selectKnownShops(text, knownIds);
    setUnknown(missing);
    onSelect(known.slice(0, MAX_SHOPS_PER_START));
  };

  return (
    <div className="flex flex-wrap items-start gap-2">
      <Textarea
        value={text}
        onChange={(event) => setText(event.target.value)}
        placeholder="Ids de shops, séparés par des espaces, virgules ou retours à la ligne"
        className="min-h-16 max-w-xl flex-1 font-mono text-xs"
      />
      <div className="space-y-1">
        <Button
          size="sm"
          variant="outline"
          disabled={text.trim().length === 0}
          onClick={apply}
        >
          Sélectionner ces shops (max {MAX_SHOPS_PER_START})
        </Button>
        {unknown.length > 0 && (
          <p className="text-xs text-amber-700">
            {unknown.length} id(s) inconnu(s) : {unknown.slice(0, 5).join(", ")}
            {unknown.length > 5 ? "…" : ""}
          </p>
        )}
      </div>
    </div>
  );
}
